import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * ThoughtBlock Component
 * 
 * Displays the AI's internal thought process (System/Thinking/Working messages)
 * in a collapsible accordion style block.
 */
const ThoughtBlock = ({
    messages = [],
    isOpen = false,
    onToggle,
    status = 'Thinking...',
    isLive = false
}) => {
    if (!messages.length && !isLive) return null;

    const lastMessage = messages[messages.length - 1];
    const subAgent = lastMessage?.subAgent;

    return (
        <div className={`collapse collapse-arrow bg-base-200/50 border border-base-200 rounded-xl my-4 max-w-3xl ${isOpen ? 'collapse-open' : 'collapse-close'}`}>
            <div
                className="collapse-title text-sm font-medium text-base-content/70 flex items-center gap-2 min-h-[3rem] py-2 cursor-pointer hover:bg-base-200/80 transition-colors"
                onClick={onToggle}
            >
                {isLive ? (
                    <span className="loading loading-spinner loading-xs text-primary"></span>
                ) : (
                    <span className="text-xl">💭</span>
                )}

                <span className="flex-1">
                    {status}
                    {subAgent && (
                        <span className="ml-2 badge badge-sm badge-ghost font-normal text-xs">{subAgent}</span>
                    )}
                </span>

                <span className="text-xs font-normal opacity-50">
                    {messages.length} step{messages.length !== 1 ? 's' : ''}
                </span>
            </div>

            <div className="collapse-content text-sm text-base-content/80 space-y-2 border-t border-base-200/50 pt-3">
                <div className="flex flex-col gap-2 pl-2">
                    {messages.map((msg, idx) => (
                        <div key={idx} className="flex items-start gap-3 py-1 group">
                            <span className="mt-1 text-xs opacity-50 min-w-[20px] text-right">{idx + 1}.</span>
                            <div className="markdown-content text-sm leading-relaxed">
                                <ReactMarkdown>{msg.content}</ReactMarkdown>
                            </div>
                        </div>
                    ))}

                    {isLive && (
                        <div className="flex items-center gap-2 py-1 pl-8 opacity-50">
                            <span className="w-2 h-2 bg-current rounded-full animate-pulse"></span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ThoughtBlock;
